module.exports = __webpack_public_path__ + "img/twitter.3eb9f07d.svg";